<script setup lang="ts">
import type { ImageData } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

defineProps<{
  data: ImageData;
  componentStyles?: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper :component-styles="componentStyles">
    <div
      class="container flex"
      :class="['flex-col md:flex-row']"
    >
      <div
        v-if="data.image && data.image.url"
        class="w-full overflow-hidden"
      >
        <BaseImage
          class="w-full"
          :image="data.image"
        />
      </div>
    </div>
  </BaseComponentWrapper>
</template>
